import { GetTrialsByUserAndInstitutionIdResponse } from "@/api/dtos";
import IsLoading from "@/components/layouts/IsLoading";
import TrialsContext from "@/contexts/data/TrialsContext";
import useTrialsByUserAndInstitutionId from "@/hooks/data/useTrialsByUserAndInstitutionId";
import { FC, PropsWithChildren } from "react";
import { useParams } from "react-router";



export interface ITrialsProps {
    initial?: GetTrialsByUserAndInstitutionIdResponse;
}

export const TrialsProvider: FC<PropsWithChildren<ITrialsProps>> = ({ initial, children }) => {

    const institutionId = useParams()?.institutionId;
    
    const trials = useTrialsByUserAndInstitutionId(institutionId ? +institutionId : undefined, {fallbackData: initial});

    return (
        <TrialsContext.Provider value={trials}>
            <IsLoading name="trials" loading={trials.loading} validating={trials.validating}/>
            {children}
        </TrialsContext.Provider>
    );
}

export default TrialsProvider;
